module.exports = __webpack_public_path__ + "static/img/3.d2824174.jpg";